const EMPTY_PARAMETERS = Object.freeze(Object.create(null));
export class Messages {
    translator;
    constructor(translator) {
        this.translator = translator;
    }
    APP_TITLE() {
        return this.translator.translate('APP_TITLE', EMPTY_PARAMETERS);
    }
    SERVER_DATABASE_LABEL() {
        return this.translator.translate('SERVER_DATABASE_LABEL', EMPTY_PARAMETERS);
    }
    IDENTITY_DATABASE_LABEL() {
        return this.translator.translate('IDENTITY_DATABASE_LABEL', EMPTY_PARAMETERS);
    }
    SKELETON_STATUS_LOADING() {
        return this.translator.translate('SKELETON_STATUS_LOADING', EMPTY_PARAMETERS);
    }
    SKELETON_STATUS_FAILED() {
        return this.translator.translate('SKELETON_STATUS_FAILED', EMPTY_PARAMETERS);
    }
    WORDMARK_LABEL() {
        return this.translator.translate('WORDMARK_LABEL', EMPTY_PARAMETERS);
    }
    ACCOUNT_MENU_DESKTOP_LABEL(email) {
        return this.translator.translate('ACCOUNT_MENU_DESKTOP_LABEL', { email });
    }
    ACCOUNT_MENU_PHONE_LABEL(email) {
        return this.translator.translate('ACCOUNT_MENU_PHONE_LABEL', { email });
    }
    SIGN_IN_WORDMARK_LABEL() {
        return this.translator.translate('SIGN_IN_WORDMARK_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_TITLE() {
        return this.translator.translate('SIGN_IN_EMAIL_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_DESCRIPTION() {
        return this.translator.translate('SIGN_IN_EMAIL_DESCRIPTION', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_LABEL() {
        return this.translator.translate('SIGN_IN_EMAIL_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_PLACEHOLDER() {
        return this.translator.translate('SIGN_IN_EMAIL_PLACEHOLDER', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_CODE() {
        return this.translator.translate('SIGN_IN_SEND_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_SENDING_CODE() {
        return this.translator.translate('SIGN_IN_SENDING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_ACCOUNT_NOTE() {
        return this.translator.translate('SIGN_IN_NEW_ACCOUNT_NOTE', EMPTY_PARAMETERS);
    }
    SIGN_IN_INVALID_EMAIL() {
        return this.translator.translate('SIGN_IN_INVALID_EMAIL', EMPTY_PARAMETERS);
    }
    SIGN_IN_USE_DIFFERENT_EMAIL() {
        return this.translator.translate('SIGN_IN_USE_DIFFERENT_EMAIL', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_TITLE() {
        return this.translator.translate('SIGN_IN_CODE_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_DESCRIPTION(email, children) {
        return this.translator.translateWithChildren('SIGN_IN_CODE_DESCRIPTION', { email }, children);
    }
    SIGN_IN_CODE_LABEL() {
        return this.translator.translate('SIGN_IN_CODE_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_SUBMIT_CODE() {
        return this.translator.translate('SIGN_IN_SUBMIT_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CHECKING_CODE() {
        return this.translator.translate('SIGN_IN_CHECKING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_COUNTDOWN() {
        return this.translator.translate('SIGN_IN_RESEND_COUNTDOWN', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_AVAILABLE() {
        return this.translator.translate('SIGN_IN_RESEND_AVAILABLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_CODE() {
        return this.translator.translate('SIGN_IN_RESEND_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESENDING_CODE() {
        return this.translator.translate('SIGN_IN_RESENDING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_ANNOUNCEMENT() {
        return this.translator.translate('SIGN_IN_RESEND_ANNOUNCEMENT', EMPTY_PARAMETERS);
    }
    SIGN_IN_WRONG_CODE_ATTEMPTS_LEFT(attemptsLeft) {
        return this.translator.translate('SIGN_IN_WRONG_CODE_ATTEMPTS_LEFT', { attemptsLeft });
    }
    SIGN_IN_WRONG_CODE_ONE_ATTEMPT_LEFT() {
        return this.translator.translate('SIGN_IN_WRONG_CODE_ONE_ATTEMPT_LEFT', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_CODE_SENT_TITLE() {
        return this.translator.translate('SIGN_IN_NEW_CODE_SENT_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_CODE_SENT_BODY() {
        return this.translator.translate('SIGN_IN_NEW_CODE_SENT_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EXPIRED_TITLE() {
        return this.translator.translate('SIGN_IN_CODE_EXPIRED_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EXPIRED_BODY() {
        return this.translator.translate('SIGN_IN_CODE_EXPIRED_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_ATTEMPTS_TITLE() {
        return this.translator.translate('SIGN_IN_TOO_MANY_ATTEMPTS_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_ATTEMPTS_BODY() {
        return this.translator.translate('SIGN_IN_TOO_MANY_ATTEMPTS_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_NEW_CODE() {
        return this.translator.translate('SIGN_IN_SEND_NEW_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_NEW_CODE_IN(time) {
        return this.translator.translate('SIGN_IN_SEND_NEW_CODE_IN', { time });
    }
    SIGN_IN_TOO_MANY_CODES_TITLE() {
        return this.translator.translate('SIGN_IN_TOO_MANY_CODES_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_CODES_BODY() {
        return this.translator.translate('SIGN_IN_TOO_MANY_CODES_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_UNAVAILABLE_TITLE() {
        return this.translator.translate('SIGN_IN_UNAVAILABLE_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_UNAVAILABLE_BODY() {
        return this.translator.translate('SIGN_IN_UNAVAILABLE_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EMAIL_SUBJECT() {
        return this.translator.translate('SIGN_IN_CODE_EMAIL_SUBJECT', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EMAIL_BODY(code) {
        return this.translator.translate('SIGN_IN_CODE_EMAIL_BODY', { code });
    }
}
//# sourceMappingURL=Messages.js.map